import React from 'react'
import { Container, Grid } from '@material-ui/core'
import { Stepper, Step } from '@progress/kendo-react-layout'
import { Form, FormElement } from '@progress/kendo-react-form'
import { DialogSystemGLPure, DialogPoliticyPrivacy, IconLanguageHLPure, ButtonHLPure } from '../../pures'
import './register-user-invited.css'
import { LogoColor } from '../../../assets/assets'
import { LocalStorageService } from '../../../services'
import { useTranslation } from 'react-i18next'

const RegisterUserInvitedView = (props) => {
  const { i18n, t } = useTranslation();

  let StepComponent = props.stepMetadata[props.selectedStep].component

  const CustomStepItem = props => {
    return (
      <Step {...props} >
        <span className='k-step-indicator'><img src={props.icon} alt='' className='item-step-icon' /></span>
        <span className='k-step-label k-step-text label-stepper '>{props.label ? t(props.label) : t(props.itemSup)}</span>
      </Step>
    )
  }

  const changePreference = (language) => {
    if (!language) return
    language = language || "es"
    props.setFlags(language)
    LocalStorageService.storeItem("preferredLanguage", language)
    i18n.changeLanguage(language);
  }

  return (
    <div className='user-register register-user-invited-container'>
      {/* Header of the page */}
      <div className='register-user-invited-header-layout'>
        <Grid container justify='center' alignItems='center'>
          <div className='header-register-person' item>
            <div className='header-register-person-items'>
              <div className='logo-register-person'><img alt='Logo de govo.legal' className='data-logo-person-header' width='247' height='48' src={LogoColor} /></div>
              {props.logo && (
                <img alt='Logo del cliente' className='data-logo-person-header' style={{ height: '80px', padding: '0px', margin: '8px' }} src={props.logo} />
              )}

              <div>
                {(props.flags && props.flags.length > 0) && (
                  <div className="loginView-flags-container">
                    <div className="loginView-world">
                      <img
                        src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_LANGUAGE_WORLD}`}
                        width={22}
                        height={22}
                        alt={'worldLanguage'}
                      />
                    </div>
                    {
                      props.flags.map((flag) => (
                        <div className="loginView-flags"
                          onClick={() => changePreference(flag.language)}
                        >
                          <IconLanguageHLPure
                            label={flag.label}
                            status={flag.status}
                          />
                        </div>
                      ))
                    }
                  </div>
                )}
              </div>
            </div>
            {/* <div className='desc-register-person'><h2>{props.selectedPersonTypeName}</h2></div> */}
            {/* <div className='data-akubicafirmadigital-person'><img alt='hibou.legal Logo' className='data-akubicaFirmaDigital-person-img' width='100' height='60' src={slogan} /></div> */}
            {/* <div className='btn-close'>
            <button className='btn-close-sesion' onClick={props.onCloseSesion}><img alt='Cerrar sesión' width="30px" className='icon-close' src={CerrarSesionImage}/>Cerrar sesion</button>
          </div> */}
          </div>
        </Grid>
      </div>
      {/* Container of body and Form */}
      <div className='register-user-invited-contnet-layout' >
        <Container fixed className='container user-register-container' >
          <Container col={12}>
            <div className='steps center'>
              <Stepper value={props.selectedStep} items={props.steps} item={CustomStepItem} />
            </div>
          </Container>
          <Form
            allowSubmit={true}
            onSubmit={props.onSubmitRegisterUserInvited}
            valid={true}
            render={(formRenderProps) => (
              <Container className='form'>
                <Container className='user-register-form' spacing={4} >
                  <FormElement style={{ maxWidth: 900 }} className={'center'}>
                    <StepComponent
                      {...props}
                      validator={props.validator}
                      regex={props.regex}
                      validateInput={props.validateInput}
                      selectedPersonTypeId={props.selectedPersonTypeId}
                    />
                    <div item xs={12} lg={12} md={12} sm={12} es={12} className="register-invited-form-container-buttons" >
                      {(props.selectedStep !== 2 || (!props.enabledSMS && props.selectedStep === 1)) &&
                        <ButtonHLPure
                          nameBtn={props.steps[props.selectedStep] == 1 ? 'cerrar' : t(props.steps[props.selectedStep].labelreturn)}
                          onClickBtn={(e) => props.steps[props.selectedStep] == 1 ? props.goToApp() : props.onBackStep(e)}
                        />
                      }
                      {props.steps[props.selectedStep] == 1 ? (
                        <ButtonHLPure
                          type='submit'
                          nameBtn={props.steps[props.selectedStep].itemMoral ? t(props.steps[props.selectedStep].itemMoral) : t(props.steps[props.selectedStep].itemSup)}
                          onClickBtn={!((formRenderProps.allowSubmit) || (props.selectedPlanPricing)) && props.onSubmitClick && props.goToApp()}
                          primary
                        />
                      ) : (
                        <ButtonHLPure
                          type='submit'
                          nameBtn={props.steps[props.selectedStep].itemMoral ? t(props.steps[props.selectedStep].itemMoral) : t(props.steps[props.selectedStep].itemSup)}
                          onClickBtn={!((formRenderProps.allowSubmit) || (props.selectedPlanPricing)) && props.onSubmitClick}
                          primary
                        />
                      )}
                    </div>
                  </FormElement>
                </Container>
              </Container>
            )} />

        </Container>
      </div>
      <div className='register-user-invited-footer-layout' >
        {/* Footer od the page */}
        {/* Alerts of Notification Loadign, Completed and Error */}
        <DialogSystemGLPure
          {...props}
          message={props.message}
          toggleLoadingRequesting={props.toggleLoadingRequesting}
          toggleCompletedRequesting={props.toggleCompletedRequesting}
          toggleErrorRequesting={props.toggleErrorRequesting}
        />
        <Grid container justify='center' alignItems='center'>
          <div className='footer-register-person' item>
            <div className='footer-elements'>
              <div className='footer-textR-person'><h2>Powered by A3 Cloud Microservices, S.A.P.I. de C.V.</h2></div>
              <div className='footer-textL-person'><h2 onClick={() => { props.openModalPolicityPrivacy(true) }}>{t("simpleFooter.noticeOfprivacy")}</h2>{/*<hr class="linkHref"/>*/}</div>
            </div>
          </div>
        </Grid>
        <DialogPoliticyPrivacy
          {...props}
        />
      </div>
    </div>
  )
}
export { RegisterUserInvitedView as default }
